import(/* webpackMode: "eager" */ "/home/ubuntu/apps/icomm/dev/icomm/app/(dashboard)/analysis/page.tsx");
